import { render, staticRenderFns } from "./departureInformation.vue?vue&type=template&id=a04bbd24&scoped=true&"
import script from "./departureInformation.vue?vue&type=script&lang=js&"
export * from "./departureInformation.vue?vue&type=script&lang=js&"
import style0 from "./departureInformation.vue?vue&type=style&index=0&id=a04bbd24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04bbd24",
  null
  
)

export default component.exports